import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import AcunetixConfigListing from './AcunetixConfigListing'
import AcunetixCredentialsForm from './AcunetixCredentialsForm'

export default function AcunetixPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={AcunetixCredentialsForm}
            PullConfigListingView={AcunetixConfigListing}
        />
    )
}
